import {
  Card as RadixCard,
  type CardProps as RadixCardProps
} from '@radix-ui/themes'
import { forwardRef } from 'react'

type CardVariant = 'surface' | 'classic'
type CardSize = '1' | '2'

interface CardProps extends Omit<RadixCardProps, 'variant' | 'size'> {
  variant?: CardVariant
  size?: CardSize
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'surface', size = '1', className = '', ...props }, ref) => {
    return (
      <RadixCard
        className={className}
        ref={ref}
        size={size}
        variant={variant}
        {...props}
      />
    )
  }
)

Card.displayName = 'Card'
